module.exports = __webpack_public_path__ + "static/media/52.fc4ca614.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/52.jpg
// module id = 996
// module chunks = 0